export default __webpack_public_path__ + "static/media/dobbi-order-module.6944c57f.jpg";